<template>
    <div>
        <div class="opui-row">
            <div class="opui-col">
                <label>{{ $e('Choose Integration') }}</label>
                <RichSelect
                    v-model="item.settings.provider"
                    modelValue="item.settings.provider"
                    :options="integrations"
                    :placeholder="'Choose integration provider'"
                    @select="providerChange"
                    :required="true"
                />
            </div>
        </div>
    </div>

    <div class="opui-row" v-if="item.settings.provider !== 'email'">
        <div class="opui-col">
            <label>{{ listLabel }}</label>
            <RichSelect
                    v-model="item.settings.list_id"
                    modelValue="item.settings.list_id"
                    :settings="{ ajax: { url: this.restUrl('flow/integration/lists?provider=' + item.settings.provider), dataType: 'json' }, allowClear: true }"
                    :ajaxUrl="restUrl('flow/integration/lists?provider=' + item.settings.provider)"
                    :placeholder="listLabel"
                    @select="listChange"
            >
                <option :value="item.settings.list_id" selected>
                    {{ item.settings.list_title ? item.settings.list_title : item.settings.list_id }}
                </option>
            </RichSelect>
        </div>

        <div class="opui-col" v-if="hasTags && supportsMultiTags">
            <label>{{ tagLabel }}</label>
            <RichSelect
                    v-model="item.settings.tag_ids"
                    modelValue="item.settings.tag_ids"
                    :settings="{ ajax: { url: this.restUrl('flow/integration/tags?provider=' + item.settings.provider), dataType: 'json' }, multiple: supportsMultiTags, tags: supportsNewTags, allowClear: true }"
                    :ajaxUrl="restUrl('flow/integration/tags?provider=' + item.settings.provider)"
                    :placeholder="tagLabel"
                    @select="tagChange"
            >
                <option v-if="supportsMultiTags && item.settings.tag_ids" v-for="tag_id in item.settings.tag_ids" :key="tag_id">
                    {{ tag_id }}
                </option>
            </RichSelect>
        </div>

        <div class="opui-col" v-if="hasTags && ! supportsMultiTags">
            <label>{{ tagLabel }}</label>
            <RichSelect
                    v-model="item.settings.tag_id"
                    modelValue="item.settings.tag_id"
                    :settings="{ ajax: { url: this.restUrl('flow/integration/tags?provider=' + item.settings.provider), dataType: 'json' }, multiple: supportsMultiTags, tags: supportsNewTags, allowClear: true }"
                    :ajaxUrl="restUrl('flow/integration/tags?provider=' + item.settings.provider)"
                    :placeholder="tagLabel"
                    @select="tagChangeSingle"
            >
                <option :value="item.settings.tag_id" selected>
                    {{ item.settings.tag_title ? item.settings.tag_title : item.settings.tag_id }}
                </option>
            </RichSelect>
        </div>

        <div class="opui-col" v-if="hasGoals">
            <label>{{ goalLabel }}</label>
            <RichSelect
                    v-model="item.settings.goal_id"
                    modelValue="item.settings.goal_id"
                    :settings="{ ajax: { url: this.restUrl('flow/integration/goals?provider=' + item.settings.provider), dataType: 'json' }, allowClear: true }"
                    :ajaxUrl="restUrl('flow/integration/goals?provider=' + item.settings.provider)"
                    :placeholder="goalLabel"
                    @select="goalChange"
            >
                <option :value="item.settings.goal_id" selected>
                    {{ item.settings.goal_title ? item.settings.goal_title : item.settings.goal_id }}
                </option>
            </RichSelect>
        </div>
    </div>

    <div class="opui-row" v-if="! item.validated" style="margin-top: -28px;">
        <div class="opui-col">
            <p style="font-size: 12px;" class="opui-text-danger">{{ $e('Please select required values') }}</p>
        </div>
    </div>

    <div class="opui-row" v-if="item.settings.provider === 'email'">
        <div class="opui-col">
            <label>{{ $e('Enter E-Mail address to override admin email') }}</label>
            <input type="text" class="opui-form-control" v-model="item.settings.email">
        </div>
    </div>

    <IntegrationFieldMap :workflow="workflow" :item="item" />


    <!-- <p><small>SET: {{ item.settings }}</small></p>
    <p><small>VAL: {{ item.validated }}</small></p>
    <p><small>REQ: {{ connectionRequirements }}</small></p> -->
</template>

<script>
import IntegrationFieldMap from "./IntegrationFieldMap.vue"
import RichSelect from "../../Global/RichSelect.vue"
import FieldMap from "./FieldMap.vue";

export default {
    components: {FieldMap, IntegrationFieldMap, RichSelect },
    props: {
        workflow: { type: Object, required: true },
        item:     { type: Object, required: true },
    },
    computed: {
        /**
         * Create trigger groups for dropdown
         * @returns {*[]}
         */
        integrations() {
            let integrations = []

            Object.entries(window.OptimizeFlow.integrations).forEach(entry => {
                const [key, item] = entry;

                integrations.push({id: item.provider, text: item.title})

            })

            return integrations
        },

        /**
         * The selected integration
         * @return {Object}
         */
        integration() {
            let integration = {}
            let provider    = this.item.settings.provider ? this.item.settings.provider : 'email'

            Object.entries(window.OptimizeFlow.integrations).forEach(entry => {
                const [key, integrationItem] = entry;

                if (provider === integrationItem.provider) {
                    integration = integrationItem
                }
            })

            return integration
        },

        /**
         * Label for list picker
         * @return {String}
         */
        listLabel() {
            return (this.integration && this.integration.config && this.integration.config.list_label) ? this.integration.config.list_label : 'Using List'
        },

        /**
         * Label for tag picker
         * @return {String}
         */
        tagLabel() {
            return (this.integration && this.integration.config && this.integration.config.tag_label) ? this.integration.config.tag_label : 'Using Tag'
        },

        /**
         * Label for goal picker
         * @return {String}
         */
        goalLabel() {
            return (this.integration &&  this.integration.config && this.integration.config.goal_label) ? this.integration.config.goal_label : 'Using Goal'
        },

        /**
         * Check if integration supports tags
         * @return {Boolean}
         */
        hasTags() {
            return (this.integration && this.integration.config && this.integration.config.has_tags) ? this.integration.config.has_tags : false
        },

        /**
         * Check if integration supports multiple tags
         * @return {Boolean}
         */
        supportsMultiTags() {
            return (this.integration && this.integration.config && this.integration.config.multi_tags) ? this.integration.config.multi_tags : false
        },

        /**
         * Check if integration supports adding new tags
         * @return {Boolean}
         */
        supportsNewTags() {
            return (this.integration && this.integration.config && this.integration.config.new_tags) ? this.integration.config.new_tags : false
        },

        /**
         * Check if integration supports goals
         * @return {Boolean}
         */
        hasGoals() {
            return (this.integration && this.integration.config && this.integration.config.has_goals) ? this.integration.config.has_goals : false
        },

        /**
         * Requirements for validation
         * @returns {*|boolean}
         */
        connectionRequirements() {
            return (this.integration && this.integration.config && this.integration.config.connection_requirements) ? this.integration.config.connection_requirements : false
        }
    },
    mounted() {
        // Set default request type
        if (! this.item.settings.provider) {
            this.item.settings.provider = 'email'
        }

        // Validate the form
        this.validate()
    },
    methods: {
        updateDescription() {
            this.item.description = 'Optin to: ' + this.item.settings.provider.toUpperCase()
        },

        /**
         * Run validation for form
         */
        validate() {
            // Unique tags
            if (this.item.settings.tag_ids) {
                this.item.settings.tag_ids = [...new Set(this.item.settings.tag_ids)]
            }

            // No requirements
            if (! this.connectionRequirements) {
                this.item.validated = true
            } else {
                // Email required
                if (this.connectionRequirements === 'admin_email') {
                    // console.log("Email");
                    this.item.validated = true
                // List only required
                } else if (this.connectionRequirements === 'list' && this.item.settings.list_id) {
                    // console.log("List is set");
                    this.item.validated = true
                // Tag only required
                } else if (this.connectionRequirements === 'tag' && this.item.settings.tag_ids) {
                    // console.log("Tag is set");
                    this.item.validated = true
                // List or tag required
                } else if (this.connectionRequirements === 'list_or_tag' && (this.item.settings.list_id || this.item.settings.tag_ids)) {
                    // console.log("List or Tag is set");
                    this.item.validated = true
                // List, tag or goal required
                } else if (this.connectionRequirements === 'list_or_tag_or_goal' && (this.item.settings.list_id || this.item.settings.tag_ids.length || this.item.settings.tag_id || this.item.settings.goal_id)) {
                    // console.log("List, tag or goal is set");
                    this.item.validated = true
                } else if (this.connectionRequirements === 'list_and_emailSequence_and_sequenceLevel' && this.item.settings.list_id) {
                    this.item.validated = true
                } else {
                    // console.log("Validation failed");
                    this.item.validated = false
                }
            }
        },

        /**
         * Update the selected text
         */
        providerChange(selected) {
            this.item.settings.list_id = ''
            this.item.settings.list_title = ''
            this.item.settings.tag_ids = []
            this.item.settings.tag_id  = ''
            this.item.settings.tag_title = ''
            this.item.settings.tag_titles = []
            this.item.settings.goal_id = ''
            this.item.settings.goal_title = ''
            this.validate()
        },

        /**
         * Update the selected text
         */
        listChange(selected) {
            this.item.settings.list_title = selected.text
            this.validate()
        },

        /**
         * Update the selected text
         */
        tagChange(selected) {
            // Unique tags
            this.item.settings.tag_ids = [...new Set(this.item.settings.tag_ids)]

            // Set titles
            this.item.settings.tag_titles = this.item.settings.tag_ids
            this.item.settings.tag_title  = this.item.settings.tag_id

            // And validate the form
            this.validate()
        },

        tagChangeSingle(selected) {
            this.item.settings.tag_title  = selected.text
            this.item.settings.tag_titles = [selected.text]
            this.item.settings.tag_ids    = [this.item.settings.tag_id]
            this.validate()
        },

        /**
         * Update the selected text
         */
        goalChange(selected) {
            this.item.settings.goal_title = selected.text
            this.validate()
        },
    }
}
</script>
